import { SELECT_LANGUAGE, SET_LANGUAGE_ISO, SET_LANGUAGES } from '../../constants/action_types';

export const setLanguages = (languages) => ({
  type: SET_LANGUAGES,
  languages,
});

export const setLanguageISO = (languageISO) => (dispatch) => {
  if (!languageISO) {
    return;
  }
  document.documentElement.lang = languageISO;

  dispatch(selectLanguageISO(languageISO));
  dispatch(selectLanguage(languageISO));
};

const selectLanguageISO = (languageISO) => ({
  type: SET_LANGUAGE_ISO,
  languageISO,
});

const selectLanguage = (languageISO) => ({
  type: SELECT_LANGUAGE,
  languageISO,
});
